import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: _jsx(_components.strong, {
        children: "How Does It Work?"
      })
    }), "\n", _jsx(_components.p, {
      children: "Formula 1, or F1, is the world’s premier motorsport championship, where the fastest cars and the greatest drivers compete across a global calendar of Grands Prix (races)."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "This isn’t just racing. It’s a blend of extreme speed, cutting-edge technology, and pure human skill, watched by millions around the world."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "The Cars"
      })
    }), "\n", _jsx(_components.p, {
      children: "F1 cars are high-tech beasts built for speed and precision."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Top Speed"
        }), ": Over 350 km/h."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Acceleration"
        }), ": 0 to 100 km/h in under 2 seconds."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Price Tag"
        }), ": Each car can cost over $15 million USD to build."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "The Teams"
      })
    }), "\n", _jsx(_components.p, {
      children: "F1 is a team sport, with 10 teams each running 2 cars. Each team has designers, engineers, strategists, mechanics, and world-class drivers all working together to win races and championships."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "The Championship"
      })
    }), "\n", _jsx(_components.p, {
      children: "Every season has about 24 races held in countries around the world, from Monaco’s tight streets to the deserts of the Middle East."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Drivers score points based on their finishing position."
      }), "\n", _jsx(_components.li, {
        children: "At the end of the season, the driver with the most points wins the Drivers' Championship."
      }), "\n", _jsx(_components.li, {
        children: "Teams also compete for the Constructors' Championship, a battle for the best overall team."
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "The Race Weekend"
      })
    }), "\n", _jsx(_components.p, {
      children: "Every Grand Prix (race weekend) follows this format:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Friday"
        }), ": Practice 1 & 2 - Drivers test the car, track, and tires."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Saturday"
        }), ": Practice 3 + Qualifying - Qualifying is a timed battle to secure the best starting position for the race."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Sunday"
        }), ": Race Day - The main event, all-out racing for victory. First car across the line wins."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "What Makes F1 So Exciting?"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Insane Speed"
        }), ": Cars corner so fast that drivers experience up to 6 G-forces (like being launched into space)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Real-time Strategy"
        }), ": Teams must manage tire wear, fuel loads, weather changes, and pit stops, every decision can change the race."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Rivalries & Drama"
        }), ": F1 is famous for fierce rivalries (like Hamilton vs Verstappen) and controversial moments (collisions, team orders, and more)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Global Show"
        }), ": F1 isn’t just a race, it’s a traveling circus, with concerts, fan festivals, and parties in every host city."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "Why F1 in Saudi Arabia is Special"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Night Racing"
        }), ": One of the few races held under floodlights, making it visually spectacular."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Street Circuit"
        }), ": Racing through the actual streets of Jeddah, walls are close, speeds are high, mistakes are costly."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Coastal Track"
        }), ": The only F1 race with views of the Red Sea."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Festival Vibes"
        }), ": Concerts, food, cultural experiences, a complete weekend experience."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "F1 by the Numbers"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "1950"
        }), ": First F1 season."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "5G"
        }), ": Forces drivers experience in corners."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "2 sec"
        }), ": Time for a full tire change pit stop."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "1.88 sec"
        }), ": Fastest pit stop ever (Red Bull, 2019)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "500 million"
        }), ": Global TV audience per season."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "Why You Need to See It Live"
      })
    }), "\n", _jsx(_components.p, {
      children: "TV is exciting, but live? It’s a sensory overload:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "The roar of engines at full speed."
      }), "\n", _jsx(_components.li, {
        children: "The smell of burning rubber."
      }), "\n", _jsx(_components.li, {
        children: "The crowd energy, every overtake feels like a goal at a football match."
      }), "\n", _jsx(_components.li, {
        children: "The speed, your eyes can barely keep up."
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "First Time? No Problem."
      })
    }), "\n", _jsx(_components.p, {
      children: "We’ve got you covered, from explaining the rules to helping you pick the right ticket (whether you want luxury or party vibes). Everyone starts somewhere, and your first race will be unforgettable."
    }), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "Ready to experience it for yourself?"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["⚡️ ", _jsx(_components.a, {
        href: "#",
        children: "Explore Tickets & Packages Now"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
